import CastIronTableImg from '../../Images/CastIronTableImg.jpg'

export default function CastIron(props) {
    return (
        <div style={{marginTop: '10px', marginLeft:'0px', border: '3px', padding:'40px', borderStyle:'solid', borderColor:'grey'}}>
               {/* <SectionTitle title={props.topicId}/> */}
               <h1>Cast Iron</h1>
               <p>
               <h2>Cast Iron Properties Table;</h2>

 <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={CastIronTableImg} alt="Cast Iron Table" width="100%"/>
                                </div>          
                        </p>
            </div>
    )
}